module.exports = __webpack_public_path__ + "static/media/S-9-Y.73381a3b.mp3";